import React, { useEffect } from "react";

function ParentsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-sky-50">
      {/* Hero Header */}
      <section className="pt-8 pb-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-emerald-600 mb-6" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            The Parent's Boutique: Curated Essentials for Your Journey
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-sky-400 mx-auto rounded-full mb-8"></div>
        </div>
      </section>

      {/* Hero Image */}
      <section className="pb-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-emerald-200">
            <img
              src="https://images.pexels.com/photos/6393342/pexels-photo-6393342.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Peaceful nursery with organized baby gear"
              className="w-full h-80 object-cover" />
          </div>
        </div>
      </section>

      {/* The Hook */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="rounded-3xl shadow-xl p-8 md:p-12 border-4 border-emerald-100 bg-[#CFFAFE]">
            <h2 className="text-3xl md:text-4xl font-black text-emerald-600 mb-6 text-center" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
              We're Building Something Special 🌱
            </h2>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center font-semibold">
              Our team is currently hand-selecting the most reliable nursery essentials, safety-tested travel gear, and everyday parenting tools to support your journey. From cribs and monitors to strollers and car seats, every product will be carefully chosen with your family's well-being in mind.
            </p>
          </div>
        </div>
      </section>

      {/* Benefit Bullets */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Safety-First Selection */}
            <div className="rounded-3xl shadow-xl p-8 text-center border-4 border-sky-300 transform transition-all duration-300 hover:scale-105 bg-[#CFFAFE]">
              <div className="text-6xl mb-4">🛡️</div>
              <h3 className="text-2xl md:text-3xl font-black text-sky-600 mb-4" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Safety-First Selection
              </h3>
              <p className="text-gray-600 font-semibold">
                Every item meets the highest safety standards for your peace of mind.
              </p>
            </div>

            {/* Parent-Tested Reliability */}
            <div className="rounded-3xl shadow-xl p-8 text-center border-4 border-yellow-300 transform transition-all duration-300 hover:scale-105 bg-[#FEF3C7]">
              <div className="text-6xl mb-4">⭐</div>
              <h3 className="text-2xl md:text-3xl font-black text-yellow-600 mb-4" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Parent-Tested Reliability
              </h3>
              <p className="text-gray-600 font-semibold">
                Real parents, real experiences—only the best make the cut.
              </p>
            </div>

            {/* Essential Gear for Every Stage */}
            <div className="rounded-3xl shadow-xl p-8 text-center border-4 border-emerald-300 transform transition-all duration-300 hover:scale-105 bg-[#CCFBF1]">
              <div className="text-6xl mb-4">🍼</div>
              <h3 className="text-2xl md:text-3xl font-black text-emerald-600 mb-4" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Essential Gear for Every Stage
              </h3>
              <p className="text-gray-600 font-semibold">
                From newborn to toddler, we've got the tools you need.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>);

}

export default ParentsPage;